






import { Component, Vue } from "vue-property-decorator";
import ExperienceDetail from "@/components/experiences/ExperienceDetail.vue";


@Component({
  components: {
    ExperienceDetail
  }
})
export default class ExperienceView extends Vue {
  mounted() {}
}
